import React from 'react'
import { Close } from 'sutra/components/Icons'
import { MultiInput as SutraMultiInput } from 'sutra/components/MultiInput/MultiInput'
import { Select as SutraSelect } from 'sutra/components/Select/Select'

import {
  KeywordRow,
  KeywordRowRemoveButton,
} from 'features/charts-v2/components/filter-popover-pane.styles'
import { type OperatorType as KeywordOperatorType } from 'features/charts-v2/components/KeywordOperatorPopover'
import { KEYWORD_OPERATORS } from 'features/charts-v2/utils/keyword-operators'

const OPERATOR_OPTIONS = KEYWORD_OPERATORS.map((operator) => ({
  value: operator,
  label: operator,
}))

interface KeywordCriterionRowProps {
  operator: KeywordOperatorType
  values: string[]
  usedOperators: Set<KeywordOperatorType>
  onOperatorChange: (operator: KeywordOperatorType) => void
  onValuesChange: (values: string[]) => void
  onRemove: () => void
}

// One keyword criterion — [Operator select] [search terms] [X]. Options
// already claimed by a sibling row are disabled in this row's operator
// select (see `usedOperators`).
export const KeywordCriterionRow: React.FC<KeywordCriterionRowProps> = ({
  operator,
  values,
  usedOperators,
  onOperatorChange,
  onValuesChange,
  onRemove,
}) => (
  <KeywordRow>
    <SutraSelect
      value={operator}
      onChange={(picked) => onOperatorChange(picked)}
      options={OPERATOR_OPTIONS.map((opt) => ({
        ...opt,
        disabled: opt.value !== operator && usedOperators.has(opt.value),
      }))}
      zIndex={2001}
    />
    <SutraMultiInput
      value={values}
      onChange={onValuesChange}
      placeholder="Type keywords and press enter to add"
    />
    <KeywordRowRemoveButton
      type="button"
      aria-label="Remove keyword criterion"
      onClick={onRemove}
    >
      <Close width={14} height={14} />
    </KeywordRowRemoveButton>
  </KeywordRow>
)
